import React, { useEffect, useState } from "react";
import MenuHeader from "./MenuHeader";
import useApi from "../hooks/useApi";
import { formatDistanceToNow } from 'date-fns';
import useAuth from "../hooks/useAuth";
import NotificationService from "../services/notification.service";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button
} from "@mui/material";
import circle from '../assets/images/circle.svg';

const Notification = () => {

  const { t, i18n } = useTranslation('profile');
  const api = useApi();
  const [currentPage, setCurrentPage] = useState(1); // Page actuelle
  const [hasMore, setHasMore] = useState(true);
  const [notifications, setNotifications] = useState([]);
  const { auth } = useAuth()
  const navigation = useNavigate();
  const goBack = () => navigation(-1);
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const loadMoreOnClick = () => {

    setCurrentPage((prev) => prev + 1);
  };

  const openUrl = async (url) => {
    console.log({ url })

    navigation(url);


  };

  const handleDelete = (e, id) => {
    e.stopPropagation();
    e.preventDefault();
    setDeleteId(id);
    setOpenDialog(true);
  };

  const handleCloseDialog = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setOpenDialog(false);
  };

  const handleConfirmDelete = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    try {
      await NotificationService.delete(deleteId, api);
      setCurrentPage(1);
      fetchNotifications(true);
    } catch (error) {
      console.error("Erreur lors du chargement des notifications:", error);
    } finally {
      setOpenDialog(false);
      setDeleteId(null);
    }
  };


  const TimeAgo = ({ date }) => {
    return (
      <span>
        {formatDistanceToNow(new Date(date), { addSuffix: true })}
      </span>
    );
  };

  const fetchNotifications = async (refresh = null) => {
    try {
      const response = await NotificationService.index({
        with: `user_id`,
        'user_id': `${auth?.user?.id}`, 'page': `${refresh ? 1 : currentPage}`, 'per_page': 5, 'sort': '-id',
      }, api)
      setHasMore(response?.last_page > response?.current_page)
      refresh ?
        setNotifications(response.data)
        :
        setNotifications((prev) => {
          const newNotifications = response.data.filter(
            (newNotif) => !prev.some((existingNotif) => existingNotif.id === newNotif.id)
          );

          return [...prev, ...newNotifications];
        });
      console.log(response, response?.last_page, response?.currentPage)

    } catch (error) {
      console.error("Erreur lors du chargement des notification:", error);

    }
  };

  useEffect(() => {


    fetchNotifications();
  }, [currentPage]);


  return (
    <>
      <MenuHeader />
      <div className="notification-breadcumb">
        <div className="turn-back">
          <div className="frame">
            <div className="div" onClick={goBack} >{"<"} Retour</div>
          </div>
        </div>
        <div className="container">

        </div>
      </div>
      <div className="container-notification">
        {notifications?.map((notification, index) => (
          <div
            className={`notification ${notification.url == "#" ? 'notif-cursor' : 'notif-cursor-point'}`}
            key={index}
            onClick={() => openUrl(notification.url)}
          >
            <div onClick={(e) => handleDelete(e, notification.id)} className="notification-close-btn">×</div>
            <Dialog open={openDialog} onClose={handleCloseDialog}
              BackdropProps={{
                sx: {
                  backgroundColor: "rgba(255, 255, 255, 0.2)",
                  backdropFilter: "blur(1px)",
                },
              }}
              PaperProps={{
                sx: {
                  borderRadius: 2,
                  boxShadow: 6,
                  backgroundColor: "rgba(255, 255, 255, 0.9)",
                  backdropFilter: "blur(1px)",
                },
              }}
            >
              <DialogTitle>{t("deleteDialog.title")}</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  {t("deleteDialog.message")}
                </DialogContentText>
              </DialogContent>
              <DialogActions sx={{ justifyContent: 'center', gap: '10px' }}>
                <Button onClick={handleCloseDialog} sx={{ color: "#333", backgroundColor: "#e0e0e0" }}>
                  {t("deleteDialog.cancel")}
                </Button>
                <Button onClick={handleConfirmDelete} color="error" variant="contained">
                  {t("deleteDialog.confirm")}
                </Button>
              </DialogActions>
            </Dialog>
            {notification?.user?.image ?
              <div className="profile-picture">
                <img src={notification?.user?.image} alt="FlySpa" className="avatar-img" />
              </div>
              :
              <div className="profile-picture">
                <img src={circle} alt="FlySpa" className="avatar-img" />
              </div>
            }
            <div className="notification-card-column">
              <div className="notification-card-header">
                <div className="notification-card-title">
                  <div className="notification-card-title-text">{notification.titre}</div>
                </div>
                <div className="notification-card-time">
                  <div className="notification-card-title-time-text"><TimeAgo date={notification.date} /></div>
                </div>
              </div>
              <div className="notification-card-content-wrapper">
                <div className="notification-card-content">
                  <div className="notification-card-content-text">{notification.message}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
        {hasMore && (
          <div className="btn-bottom">
            <button className="loading-more-btn btn btn-primary" onClick={loadMoreOnClick}>
              {t('profile:load')}
            </button>
          </div>
        )}

      </div>
    </>
  );
};

export default Notification;